import ClientTable from './ClientTable';
export default ClientTable;